module.exports = __webpack_public_path__ + "static/img/pay-icon02-ov.ea28ec97.svg";